// extracted by mini-css-extract-plugin
module.exports = {"making-excuse__wrapper":"making-excuse_making-excuse__wrapper__ZLExk","making-excuse__title":"making-excuse_making-excuse__title__Fxhax"};